const config = {
  // time to cache masterData API calls
  // prod: 15min
  // dev: 30 days
  // to clear, clear localstorage/indexdb
  MasterDataCacheMin: process.env.NODE_ENV === 'production' ? 15 : 60 * 24 * 30,
};

export default config;
